import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import Header from '../Header/Header';
import NavBox from '../NavBox/NavBox';
import * as actions from '../../actions/index';

import './GroupNavStage.css';

class GroupNavStage extends Component {
  render() {
    const onClick = (navTo) => (this.props.goToStage(navTo));

    return (
      <section className={"groupNavStage " + (this.props.group.stages.length - 1 > 3 ? 'multi-row' : 'single-row') + ((this.props.group.stages.length - 1) === 2 ? ' wider-box' : '')} >
        <Header
          title={this.props.data.title}
        />
        <section className="groupNavStage__navArea">
          {
            this.props.group.stages.slice(1).map((item, itemPos) => (
              <NavBox
                key={item.id}
                title={item.title}
                thumbnail={item.image}
                navTo={itemPos+1}
                isLargeBox={(this.props.group.stages.length - 1 > 3 ? false : true)}
                onClick={onClick}
              />
            ))
          }
        </section>
      </section>
    )
  }
}



function mapDispatchToProps(dispatch) {
  return {
    goToSection: (sectionID) => {
      dispatch(actions.goToSection(sectionID));
    },
    goToGroup: (groupID) => {
      dispatch(actions.goToGroup(groupID));
    },
    goToStage: (stageID) => {
      dispatch(actions.goToStage(stageID));
    }
  };
};

GroupNavStage.propTypes = {
  data: propTypes.object.isRequired,
  group: propTypes.object.isRequired,
  goToGroup: propTypes.func.isRequired,
  goToSection: propTypes.func.isRequired,
  goToStage: propTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(GroupNavStage);




// WEBPACK FOOTER //
// ./src/components/GroupNavStage/GroupNavStage.js